import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import axios from "axios";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
Vue.use(Toast);

axios.defaults.headers.common.Authorization = `Bearer ${store.getters.userInfo.accessToken}`;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
